<template>
  <div class="content">

    <b-container fluid class="pr-3 pl-3">
      <b-row class="date_range_input_div_contain pr-3 pl-3 mt-3">
        <date_range @update_values="updated_range" :default_start="start_of_month" :default_end="end_of_month"></date_range>
      </b-row>

      <b-row class="top_stats_cards mt-3">
        <b-col xl="3" md="6">
          <stats-card title="Total Messages Sent"
                      class="number_stat"
                      type="gradient-green"
                      :sub-title=this.count_all_combined_sent_this_month
                      icon="send">

            <template slot="footer" class="mt-0">
              <span class="text-nowrap mt-0" v-if="typeof start_range_value === 'object' && start_range_value !== null && typeof end_range_value === 'object' && end_range_value !== null " >{{start_range_value.format('MMM DD, YY')}} - {{end_range_value.format('MMM DD, YY')}}</span>
            </template> 
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Failed Sends"
                      class="number_stat"
                      type="gradient-red"
                      :sub-title=this.count_failed_this_month
                      icon="device_unknown">
            <template slot="footer">
              <span class="text-nowrap" v-if="typeof start_range_value === 'object' && start_range_value !== null && typeof end_range_value === 'object' && end_range_value !== null ">{{start_range_value.format('MMM DD, YY')}} - {{end_range_value.format('MMM DD, YY')}}</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Bounces"
                      class="number_stat"
                      type="gradient-red"
                      :sub-title=this.$parent.stats.count_bounced_this_month
                      icon="fmd_bad">

            <template slot="footer">
              <span class="text-nowrap" v-if="typeof start_range_value === 'object' && start_range_value !== null && typeof end_range_value === 'object' && end_range_value !== null ">{{start_range_value.format('MMM DD, YY')}} - {{end_range_value.format('MMM DD, YY')}}</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6" v-if="this.count_all_combined_survey_question_answers_this_month">
          <stats-card title="Survey Question Responses"
                      class="number_stat"
                      type="gradient-green"
                      :sub-title=this.count_all_combined_survey_question_answers_this_month
                      icon="flaky">

            <template slot="footer">
              <span class="text-nowrap" v-if="typeof start_range_value === 'object' && start_range_value !== null && typeof end_range_value === 'object' && end_range_value !== null ">{{start_range_value.format('MMM DD, YY')}} - {{end_range_value.format('MMM DD, YY')}}</span>
            </template>
          </stats-card>
        </b-col>


        
        
      </b-row>
      <b-row class="pr-3 pl-3">
        <h2 class="mb-2">Message Stats By Campaign</h2>
      </b-row>

      <div v-if="this.$parent.fetching_stats_status.complex_twilio_stats && this.$parent.fetching_stats_status.complex_twilio_stats === true">
        <div style="max-width: 80px;margin:0 auto;">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="L4" x="0px" y="0px" enable-background="new 0 0 0 0" xml:space="preserve" viewBox="0 44 52 12" style="max-width:80px">
            <circle fill="var(--blue)" stroke="none" cx="6" cy="50" r="6">
                <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"/>    
            </circle>
            <circle fill="var(--blue)" stroke="none" cx="26" cy="50" r="6">
                <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"/>       
            </circle>
            <circle fill="var(--blue)" stroke="none" cx="46" cy="50" r="6">
                <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"/>     
            </circle>
          </svg>
        </div>
      </div>
      <div v-else>
        <b-row class="pr-3 pl-3 stats_table_contain" v-if="typeof this.$parent.delivery_rows !== 'undefined' && Array.isArray(this.$parent.delivery_rows) && this.$parent.delivery_rows.length > 0  ">
          <b-col class="p-0">
            
            <!-- these campaigns delivery table -->
            <vue-good-table
              :columns="this.delivery_columns"
              :rows="this.$parent.delivery_rows"
              :sort-options="{
                enabled: true,
                //initialSortBy: {field: 'date_created', type: 'desc'}
              }"
              :group-options="{
                enabled: true,
                headerPosition: 'top',
                collapsable:true
              }"
            >

              <template slot="table-header-row" slot-scope="props">
                <h2>{{ props.row.label }}</h2>
                <div class="therm_summary">

                </div>
              </template>
                <template slot="table-row" slot-scope="props">

              <div v-if="props.column.field == 'bounces'">
                {{parseFloat((props.row.failed+props.row.undelivered)/(props.row.unique_messages)*10).toFixed(2)}} %
              </div>

              <!--
                TODO add survey question download buttons here or something?
              <div v-else-if="props.column.survey_question_responses">
          
              </div>
              -->
              
            
              
            </template>
            </vue-good-table>
            
            
          </b-col>
        </b-row>
      </div>
     
      
       
          <!--
           <b-row class="pr-3 pl-3">


          <p :on-clck="this.$refs.stats_table.expandAll()">Expand All</p>
          <p :on-clck="this.$refs.stats_table.collapseAll()">Collapse All</p>
           </b-row>
          -->
       

      
    </b-container>
  </div>
</template>

<script>
  
  import StatsCard from '@/components/Cards/StatsCard';
  import 'vue-good-table/dist/vue-good-table.css'
  import date_range from '@/components/daterange.vue'
  import { VueGoodTable } from 'vue-good-table';
  import moment from 'moment';



  //import bar_chart from '@/views/bar_chart.vue'

  export default {
    components: {
      StatsCard,
      VueGoodTable,
      date_range
    },
     data() {
      return {
        start_of_month: moment().startOf('month'),
        end_of_month: moment().endOf('month'),
        start_range_value: null,
        end_range_value: null,

        count_bounces: 0,
        //send stats by campaign table
        delivery_columns: [
          {
            label: 'Script',
            field: 'script_name',
          },
          //{
          //  field:'date_created',
          //  label:"Date Created"
          //},
          
          {
            label: 'Total',
            field: 'unique_messages',
            type: 'number',
          },
          {
            label: 'Delivered',
            field: 'delivered',
            type: 'number',
          },
          {
            label: 'Delivery Unknown',
            field: 'delivery_unknown',
            type: 'number',
          },
          {
            label: 'Undelivered',
            field: 'undelivered',
            type: 'number',
          },
          {
            label: 'Failed',
            field: 'failed',
            type: 'number',
          },
          {
            label: 'Bounce %',
            field: 'bounces',
            sortable:false
            //sortFn: this.sort_percent,
          },{
            label: 'SC Resonses',
            field: 'survey_question_responses',
            sortable:false
            //sortFn: this.sort_percent,
          }
          
          //{
          //  label: 'Percent',
          //  field: 'score',
          //  type: 'percentage',
          //},
        ]
      }
    },

    computed: {
      //basic summary stats for cards up top
      count_all_combined_sent_this_month: function() {
        if(typeof this.$parent.fetching_stats_status.outbound_messages !== 'undefined' && this.$parent.fetching_stats_status.outbound_messages === true) {
          return '⟳'
        } else {
          return ( ( this.$parent.stats.messages_this_month.count_all_accepted || 0) + (this.$parent.stats.messages_this_month.count_all_error || 0) ).toLocaleString() || 0
        }
        
      },
      count_failed_this_month: function() {
        if(typeof this.$parent.fetching_stats_status.outbound_messages !== 'undefined' && this.$parent.fetching_stats_status.outbound_messages === true) {
          return '⟳'
        } else {
          return (this.$parent.stats.messages_this_month.count_all_error || 0).toLocaleString()
        }
      },
      count_all_combined_survey_question_answers_this_month: function() {

        if(typeof this.$parent.fetching_stats_status.outbound_messages !== 'undefined' && this.$parent.fetching_stats_status.outbound_messages === true) {
          return '⟳'
        } else {
          if(typeof this.$parent.stats.survey_question_answers !== 'undefined' && this.$parent.stats.survey_question_answers.length && this.$parent.stats.survey_question_answers.length > 0) {
            let count_all = 0
            this.$parent.stats.survey_question_answers.forEach(grouped_answer => {
              if(typeof grouped_answer.count_all !== 'undefined') {
                count_all = count_all + grouped_answer.count_all
              }
            });
            return count_all.toString()
          } else {
            return "0"
          }
        }
      }
    },
    methods: {
      updated_range: function(values) {
        //{start:start,end:end} moment objects

        //timing problems this is calling before the index vue data calls it first
        if(this.$parent.init_data_loaded && this.$parent.init_data_loaded === true) {
          if(typeof values === 'undefined' || values === null) {
            console.log('error no range values?')
          } else {
            this.start_range_value = values.start
            this.end_range_value = values.end

            this.$parent.get_twilio_logs_complex_stats_join_campaign(null,this.$parent.process_get_twilio_logs_complex_stats_join_campaign,values.end.unix(),values.start.unix()) //before,after
            this.$parent.get_generic_stats(values.end.unix(),values.start.unix())

          }
          
        }
      },
      sort_percent: function(x, y, col, rowX, rowY) {

        let first_row_percent = ( (rowY.failed+rowY.undelivered)  / rowY.unique_messages)
        let second_percent = ( (rowX.failed+rowX.undelivered)  / rowX.unique_messages)

        return (second_percent < first_row_percent ? -1 : (second_percent > first_row_percent ? 1 : 0));
      }
    },
    mounted:function() {
      
    }
  };
</script>
<style>
  .number_stat .col span.h2 {
    font-size:42px;
  }
  .top_stats_cards .card-body {
    border: 1px solid var(--blue);
  }
  .stats_table_contain .vgt-table th.vgt-row-header .triangle, .stats_table_contain .vgt-row-header .triangle {
    float:left;
    margin-top: 5px;
  }
  .stats_table_contain .vgt-row-header h2 {
    margin-bottom:0px;
    max-width: 60%;
  }
  .therm_summary {
    float:right;
    width: 30%;
  }



</style>
